import { route as cancellationRoute } from './pages/cancellation';
import { route as seatsRoute } from './pages/seats';
import { route as checkoutFlightSummaryRoute } from './pages/checkout_flight_summary';
import { route as checkoutPassengersRoute } from './pages/checkout_passengers';
import { route as checkoutPaymentRoute } from './pages/checkout_payment';
import { route as confirmBookingRoute } from './pages/confirm_booking';
import { route as checkoutFlashOfferRoute } from './pages/checkout_flash_offer';
import { route as disruptionCompensationRoute } from './pages/disruption_compensation';
import { route as flexibilityBundleRoute } from './pages/flexibility_bundle';
import { route as insurancesRoute } from './pages/insurances';
import { route as membershipPageRoute } from './pages/membership_page';
import { route as supportPackRoute } from './pages/support_pack';
import { route as checkoutAncillariesRoute } from './pages/checkout_ancillaries';
import { route as checkoutPrimeSubscriptionRoute } from './pages/checkout_prime_subscription';
import { createShell } from '../../shell/createShell';
import { createCheckoutIntegration } from './integration';
import { CheckoutFlightsFunnel } from '.';
import { route as additionsRoute } from './pages/additions';
import { route as ancillariesHubRoute } from './pages/ancillaries_hub';
import { route as flexibilityBundleHubRoute } from './pages/flexibility_bundle_hub';
import { route as insurancesHubRoute } from './pages/insurances_hub';
import { route as canxHubRoute } from './pages/canx_hub';
import { route as supportPackHubRoute } from './pages/support_pack_hub';
import { route as additionsHubRoute } from './pages/additions_hub';
import { route as disruptionCompensationHubRoute } from './pages/disruption_compensation_hub';
const routes = [additionsRoute, cancellationRoute, seatsRoute, checkoutFlightSummaryRoute, checkoutPassengersRoute, checkoutPaymentRoute, confirmBookingRoute, checkoutFlashOfferRoute, disruptionCompensationRoute, flexibilityBundleRoute, insurancesRoute, membershipPageRoute, supportPackRoute, checkoutAncillariesRoute, checkoutPrimeSubscriptionRoute, ancillariesHubRoute, flexibilityBundleHubRoute, insurancesHubRoute, canxHubRoute, supportPackHubRoute, additionsHubRoute, disruptionCompensationHubRoute];
const createAppProps = props => props;
export const checkoutShell = createShell(CheckoutFlightsFunnel, {
  options: {
    routes,
    namespace: 'checkout'
  },
  createAppProps,
  createIntegration: createCheckoutIntegration
});